<div [class.active]="active"
     class="bb-product-item bb-product-item-basic-account-ui product-item">
  <div class="bb-stack bb-stack--wrap product-item-content">
    <div class="bb-stack__item bb-product-item__title">
      <div class="bb-stack">

        <ng-container>
          <div class="bb-stack__item bb-product-item__active"
               *ngIf="active && !selected">
            <bb-icon-ui name="success"
                        size="md"
                        color="primary"
                        cropped></bb-icon-ui>
          </div>
          <div class="bb-stack__item bb-product-item__type"
               *ngIf="type && selected">
            <bb-icon-ui color="secondary"
                        size="md"
                        [name]="type"
                        cropped></bb-icon-ui>
          </div>
        </ng-container>

        <ng-container>
          <div class="bb-account-info">
            <div (mousedown)="$event.stopPropagation()"
                 data-role="card-title"
                 class="bb-account-info__title"
                 [ngClass]="{ 'bb-text-support': status === 'inactive' || status === 'closed' }">

              <bb-ellipsis-ui [text]="title"></bb-ellipsis-ui>
              <bb-icon-ui *ngIf="favorite"
                          class="bb-account-info__icon"
                          size="sm"
                          [color]="favoriteIconColor"
                          data-role="favorite-icon"
                          name="star">
              </bb-icon-ui>

              <span class="bb-account-info__status bb-account-status"
                    [ngSwitch]="status">
                <ng-container *ngSwitchCase="'closed'">
                  <bb-icon-ui class="bb-account-status__icon"
                              size="sm"
                              name="cancel"
                              color="danger"></bb-icon-ui>
                  <span class="bb-account-status__state"
                        i18n="Account closed status@@product-item-base-account.status.closed">
                    Closed
                  </span>
                </ng-container>
                <ng-container *ngSwitchCase="'inactive'">
                  <bb-icon-ui class="bb-account-status__icon"
                              size="sm"
                              name="remove-circle-outline"></bb-icon-ui>
                  <span class="bb-account-status__state"
                        i18n="Account closed status@@product-item-base-account.status.inactive">
                    Inactive
                  </span>
                </ng-container>
              </span>
            </div>
            <div *ngIf="productNumber"
                data-role="card-sub-title"
                class="bb-stack bb-account-info__product-number">
              <ng-container *ngIf="bankBranchCode">
                <span class="sr-only"
                      i18n="Bank branch code screen reader label@@product-item-base-account.bankBranchCode.label">
                  ; Bank branch code:
                </span>
                <span data-role="branch-code-text">{{ bankBranchCode }}&nbsp;/&nbsp;</span>
              </ng-container>
              <span class="sr-only"
                    i18n="Account number screen reader label@@product-item-base-account.accountNumber.label">
                ; Account number:
              </span>
              <div class="bb-ellipsis bb-ellipsis--single-line">{{ applyMaskToCreditCardNumber(productNumber) }}</div>
            </div>



          </div>
        </ng-container>

      </div>
    </div>
    <div class="bb-stack__break bb-stack__break--xs"></div>
    <div class="bb-stack__item bb-stack__item--push-right bb-stack__item--spacing-none bb-product-item__details">

      <ng-container>
        <div class="bb-text-align-right">
          <span *ngIf="!balanceLabel"
                class="sr-only"
                i18n="Balance screen reader label@@product-item-base-account.balance.label">
            ; Balance:
          </span>
          <div class="d-flex flex-column">
            <bb-amount-ui class="bb-highlight bb-product-item__amount font-weight-bold"
                          [amount]="amount"
                          [currency]="currency + '$ '"
                          [mapCurrency]="showCurrencySymbol"
                          [bbHighlight]="highlight">
            </bb-amount-ui>

            <bb-amount-ui *ngIf="foreignAmount"
                          class="bb-highlight bb-product-item__amount font-weight-bold"
                          [amount]="foreignAmount"
                          [currency]="foreignCurrency + '$ '"
                          [mapCurrency]="showCurrencySymbol"
                          [bbHighlight]="highlight">
            </bb-amount-ui>
          </div>

          <div *ngIf="amount && balanceLabel">
            <span class="bn-sub-header-account-selector"
                  data-role="balance-type-label">
              {{ balanceLabel }}
            </span>
          </div>
        </div>


      </ng-container>

    </div>
    <ng-container *ngIf="productDetailsInfo?.owners">
      <div class="bb-stack__break--xs bb-stack__break--sm-up"></div>
      <div class="bb-stack__item bb-product-item__owners">
        <span data-role="productDetailsInfo-owners"
              class="bb-text-default">
          {{ productDetailsInfo?.owners }}
        </span>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #defaultProductItemBasicAccountType>
  <div class="bb-stack__item bb-product-item__active"
       *ngIf="active && !selected">
    <bb-icon-ui name="success"
                size="md"
                color="primary"
                cropped></bb-icon-ui>
  </div>
  <div class="bb-stack__item bb-product-item__type"
       *ngIf="type && selected">
    <bb-icon-ui color="secondary"
                size="md"
                [name]="type"
                cropped></bb-icon-ui>
  </div>
</ng-template>
<div style="display: none;">
  <div i18n="@@transfers.account-selector.available-balance">Available balance</div>
</div>
